import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createItemCategory,
  findAllActiveItemCategory,
  getAllItemCategory,
  getItemCategoryById,
  updateItemCategory,
} from "./services/Itemcategory.services";
import { clearItemCategoryDetails } from "./itemCategorySlice";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormRichTextField from "../../components/formFields/FormRichTextField";

const CreateItemCategory: React.FC = () => {
  const formLoading = useAppSelector((state) => state.itemCategory.formLoading);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);
  const ItemCategoryDetail = useAppSelector(
    (state) => state.itemCategory.ItemCategoryDetail
  );
  const ItemGUID = useAppSelector((state) => state.muidrawer.data);
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  useEffect(() => {
    return () => {
      dispatch(clearItemCategoryDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (ItemGUID) {
      dispatch(getItemCategoryById(ItemGUID));
    }
  }, [ItemGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!ItemGUID) {
        const payload = {
          item_category: values.item_category,
          remarks: values.remarks,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createItemCategory(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearItemCategoryDetails());
          isIndirect
            ? dispatch(findAllActiveItemCategory())
            : dispatch(getAllItemCategory());
        }
      } else {
        const payload = {
          item_category_guid: ItemGUID,
          item_category: values.item_category,
          remarks: values.remarks,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateItemCategory(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearItemCategoryDetails());
          isIndirect
            ? dispatch(findAllActiveItemCategory())
            : dispatch(getAllItemCategory());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={ItemCategoryDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {ItemGUID ? "Update Item Category" : "Add Item Category"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="item_category"
                label="Item Category"
                placeholder="Item Category"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="remarks"
                label="Remarks"
                placeholder="Remarks"
                component={FormRichTextField}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator} astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "start",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={ItemGUID ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateItemCategory;
